import React from 'react';
// import {Button} from 'react-bootstrap';
import './bttn.css';
export default function Bttn() {
  return (
    <>
        <div className="b"><button >Buy Now</button></div>
    </>
  );
}

